import {refreshToken, getToken} from '@/services/auth-service';

export default async function auth({next, router}) {
    if (!localStorage.getItem('vue-token') || await checkTokenExpire()) {
        return router.push({name: 'login'});
    }
    return next();
}

async function checkTokenExpire() {
    const token = getToken();
    let dateNow = new Date();
    let dateExpire = new Date(token.user.expires_at * 1000);
    let dateDiff = (dateNow - dateExpire) / 1000;
    if (dateDiff >= 0) {
        localStorage.removeItem('vue-token');
        return true;
    } else {
        if (token.user.remember == true) {
            if (dateDiff > (60*60*24*4*-1)) {
                await refreshToken();
            }
        } else {
            if (dateDiff > (60*60*6*-1)) {
                await refreshToken();
            }
        }
    }
    return false;
}
